// extracted by mini-css-extract-plugin
export default {"Item":"OptionItem_Item__5SPAx"};